import { connect } from "react-redux";
import ContentItemDetails from "../ContentItemDetails";

const mapStateToProps = state => ({
    modal: state.modal,
    lang: state.lang
});

export default connect(mapStateToProps)(ContentItemDetails);
